import React from "react";
import { Col, Space } from "antd";

import EventUserList from "../../components/EventUserList";
import EventPrizeList from "../../components/EventPrizeList";

function Campingfair() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">2023 캠핑대전</h3>
                <EventUserList eventId={1} />
                <EventPrizeList eventId={1} />
            </Space>
        </div>
    );
}

export default Campingfair;
